import React from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import IbButton from '../common/IbButton';
import IbIcon, { IbIconName } from '../common/IbIcon';
import IbTooltip from '../common/IbTooltip';
import IbTypography from '../common/IbTypography';

import { COLUMN_CLASS_NAME, ITEM_CLASS_NAME, LIST_CLASS_NAME, MAIN_CLASS_NAME } from './const';

export interface ICardContentItem {
  key: string;
  iconName: IbIconName;
  displayName: string;
}

interface ICardContentProps {
  instructions?: string;
  items?: ICardContentItem[];
  itemsLabel?: string;
  onShowFullInstructions?: () => void;
  onShowAllItems?: () => void;
}

const CardContent: React.FC<ICardContentProps> = ({
  instructions,
  items,
  itemsLabel,
  onShowFullInstructions,
  onShowAllItems,
}) => {
  const { t } = useTranslation();
  const hasInstructions = !!(instructions || '').trim().length;
  const hasItems = !!(items || []).length;

  if (!hasInstructions && !hasItems) {
    return <div className={MAIN_CLASS_NAME} />;
  }

  const itemsColumnClasses = hasInstructions ? [COLUMN_CLASS_NAME, LIST_CLASS_NAME] : [COLUMN_CLASS_NAME];

  const onInstructionsClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onShowFullInstructions?.();
  };

  const onItemsClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onShowAllItems?.();
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      {hasInstructions && (
        <div className={COLUMN_CLASS_NAME}>
          <IbButton type="link" onClick={onInstructionsClick}>
            {t('Card Content: Prompt: All')}
          </IbButton>
          <IbTypography.Paragraph light type="descriptor">
            {instructions}
          </IbTypography.Paragraph>
        </div>
      )}
      {hasItems && (
        <div className={itemsColumnClasses.join(' ')}>
          <IbButton type="link" onClick={onItemsClick}>
            {itemsLabel}
          </IbButton>
          {items.map((item) => (
            <div key={item.key} className={ITEM_CLASS_NAME}>
              <IbIcon iconName={item.iconName} size={16} />
              <IbTooltip title={item.displayName}>
                <IbTypography.Paragraph ellipsis type="descriptor">
                  {item.displayName}
                </IbTypography.Paragraph>
              </IbTooltip>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardContent;
